var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "product-function"
  }, [_vm._m(0), _c("div", {
    staticClass: "product-container"
  }, [_vm._m(1), _c("section", {
    staticClass: "product-function__catagory"
  }, [_c("ul", _vm._l(_vm.categoryList, function (item) {
    return _c("li", {
      key: item.group_code,
      class: {
        actived: _vm.activedIndex === item.group_code
      },
      on: {
        click: function ($event) {
          return _vm.handleClickCatagory(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.group_name) + " ")]);
  }), 0)]), _c("section", {
    staticClass: "product-function__list"
  }, [_c("a-spin", {
    attrs: {
      spinning: _vm.loading
    }
  }, [_c("function-list", {
    attrs: {
      list: _vm.list,
      componentType: _vm.activedIndex
    }
  })], 1)], 1)])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", {
    staticClass: "product-function__title area"
  }, [_c("h4", {
    staticClass: "puhui-M"
  }, [_c("span", [_vm._v("FUNCTION")]), _c("span", [_vm._v("功能介绍")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", {
    staticClass: "product-function__banner"
  }, [_c("h4", [_c("img", {
    attrs: {
      src: require("@/assets/images/persoanl/title-left.png"),
      alt: ""
    }
  }), _c("span", {
    staticClass: "product-title"
  }, [_vm._v("接入同花顺AI能力 打造极致金融产品")]), _c("img", {
    attrs: {
      src: require("@/assets/images/persoanl/title-right.png"),
      alt: ""
    }
  })])]);
}];
render._withStripped = true;
export { render, staticRenderFns };